module.exports = __webpack_public_path__ + "static/img/product_images_03.95f4820.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/chataxera/product_images_03.png
// module id = ELkH
// module chunks = 34